var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7603 61.9845V75.5772H53.1919L44.1613 70.1772V61.9845H65.7603Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.463 72.3174V86.4213H85.3156V75.777L67.8074 75.7212",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5424 75.5754V64.2174L80.5632 57.1418L73.1154 58.6314L77.2117 70.6416V75.5754",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4205 65.8923H58.7786C60.7337 65.8923 62.5956 66.525 62.5956 68.685",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6058 70.3644H58.9639C60.9189 70.3644 62.7809 70.9971 62.7809 73.1571",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1253 80.9358H67.3434C65.5745 80.9358 59.8954 81.3642 59.8954 83.8212",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3157 86.4204L93.9699 77.532L89.2215 71.4804L85.3157 75.7203",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.764 27.0882L123.916 20.4884L126.219 20.6311L131.078 25.321L134.437 56.2686M123.251 32.9242L131.032 57.2413",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.527 59.7656C135.698 56.8308 133.061 57.2911 130.45 59.9567C127.838 62.6226 120.866 63.1959 116.861 62.1798C117.131 62.6406 119.611 63.9339 122.988 65.1093C127.208 66.5781 126.128 67.2711 129.849 68.9253C135.754 71.5515 138.563 68.3106 137.371 64.9743C136.181 61.638 135.401 61.9539 135.527 59.7656Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3157 75.7212L86.1492 46.1571C86.4595 44.2951 88.0856 40.236 92.1078 38.8954C96.129 37.5547 113.892 31.2612 122.271 28.282C124.444 28.6545 127.597 29.8648 122.83 31.7267C116.872 34.0542 96.111 42.9917 94.2489 43.5503C92.7594 43.9972 92.2005 48.5156 92.1078 50.719L91.638 74.7483",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7194 97.597C85.2705 97.597 86.5279 96.3397 86.5279 94.7886C86.5279 93.2375 85.2705 91.9801 83.7194 91.9801C82.1684 91.9801 80.911 93.2375 80.911 94.7886C80.911 96.3397 82.1684 97.597 83.7194 97.597Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9687 97.597C49.5197 97.597 50.7771 96.3397 50.7771 94.7886C50.7771 93.2375 49.5197 91.9801 47.9687 91.9801C46.4176 91.9801 45.1602 93.2375 45.1602 94.7886C45.1602 96.3397 46.4176 97.597 47.9687 97.597Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0619 88.8162H84.1844C87.5351 88.8162 90.2514 91.5325 90.2514 94.8831V94.8832C90.2514 98.2339 87.5351 100.95 84.1844 100.95H48.0619C44.7113 100.95 41.995 98.2339 41.995 94.8832V94.8831C41.995 91.5325 44.7113 88.8162 48.0619 88.8162Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.105 93.6483H79.1922",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1039 95.9487H79.1911",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4358 61.8261H49.3778H48.3537V44.6958C48.3537 44.6958 50.1351 44.472 51.2398 44.6958C54.219 45.2994 51.2398 58.9399 51.2398 58.9399C51.2398 58.9399 62.863 56.5195 63.4358 58.9399C63.6952 60.0369 63.4358 61.8261 63.4358 61.8261Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7296 23.2371H39.5998V86.0649H41.7296V23.2371Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.e9a86aa2828a6fef2f74d174a739716c.svg";
export { ForwardRef as ReactComponent };